module.exports = __webpack_public_path__ + "img/turistico.4378d48b.jpg";